import { FC } from 'react';
import { useTranslation } from '@jobcost-monorepo/i18n';
import { Button } from '@jobcost-monorepo/ui';
import { useFormContext } from 'react-hook-form';
import React from 'react';

const TypeOfPaymentGenerateButton: FC = () => {
  const { t } = useTranslation('type-of-payments');
  const daysLabel = t('form.daysLabel');
  const endMonthLabel = t('form.endOfMonthLabel');
  const invoiceDateLabel = t('form.invoiceDateLabel');
  const { getValues, setValue } = useFormContext();

  const generateName = (): void => {
    const daysToFirstPayment = getValues('daysToFirstPayment');
    const numberOfPayments = getValues('numberOfPayments');
    const daysBetweenPayments = getValues('daysBetweenPayments') ?? 0;
    const endMonth = getValues('movePaymentsToTheEndOfMonth');
    const daysOffset = getValues('daysOffsetPayments');
    const daysOffsetPaymentsLabel = daysOffset
      ? `(+${daysOffset}${daysLabel})`
      : '';

    if (!numberOfPayments) {
      setValue('name', '');
      return;
    }
    if (
      numberOfPayments === 1 &&
      daysBetweenPayments === 0 &&
      endMonth === false
    ) {
      setValue('name', `A vista ${daysOffsetPaymentsLabel}`);
      return;
    }
    if (numberOfPayments <= 12) {
      let name =
        daysToFirstPayment > 0
          ? String(daysToFirstPayment)
          : String(daysBetweenPayments);
      for (let i = 1; i < numberOfPayments; i++) {
        daysToFirstPayment > 0
          ? (name += `-${
              Number(daysToFirstPayment) + i * Number(daysBetweenPayments)
            }`)
          : (name += `-${
              Number(daysBetweenPayments) + i * Number(daysBetweenPayments)
            }`);
      }
      name += ` ${daysLabel} ${
        endMonth ? endMonthLabel : invoiceDateLabel
      } ${daysOffsetPaymentsLabel}`;
      return setValue('name', name);
    }
    const sfasamentoDescription = daysBetweenPayments
      ? `  ${Number(daysBetweenPayments)} ${daysLabel}`
      : '';
    const name = `${numberOfPayments} ${sfasamentoDescription} ${
      endMonth ? endMonthLabel : invoiceDateLabel
    } ${daysOffsetPaymentsLabel}`;
    setValue('name', name);
  };

  return (
    <div className="flex flex-col justify-center align-middle space-x-4">
      <Button type="button" onClick={generateName}>
        {t('form.generateName')}
      </Button>
    </div>
  );
};

export default TypeOfPaymentGenerateButton;
